export default __webpack_public_path__ + "static/media/Iphone.0fc7d693.png";